import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ReportCardItem } from "@Components/FollowUp/Report/ReportCardItem"
import { ToolboxAPACardItem } from "@Components/FollowUp/Toolbox/ToolboxAPACardItem"
import { ToolboxMenuOfWeekCardItem } from "@Components/FollowUp/Toolbox/ToolboxMenuOfWeekCardItem"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { ScrollView } from "react-native"

export const ToolBoxHome = ({ navigation }) => {
    const reports = ["28/11/2020", "15/09/2020", "28/06/2020"]
    return (
        <ContainerStackScreen>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    Ma boîte à outils
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={16}>
                    Retrouvez des outils pédagogiques, sur le plan sportif ou nutritionnel, afin de vous aider à
                    progresser et suivre votre évolution.
                </OpenSansText>
                <Spacer height={25} />
                <ToolboxAPACardItem onPress={() => navigation.navigate("ToolBoxForm")} />
                {/* <ToolboxMenuOfWeekCardItem /> */}
                <Spacer height={15} />
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
